/*! fl-route-hist.js 1.0 (28.09.2026) - haelt die Seitenroute ueber Sitzungsgrenzen hinweg.
    fl-attribution.js legt seine Sitzungsspur in sessionStorage ab. Wer den Warenkorb an
    einem Tag fuellt und Tage spaeter kauft, verliert damit genau die Sitzung, in der die
    Kaufentscheidung fiel: _fl_route zeigt dann nur noch die letzte Landung.
    Diese Datei spiegelt die Spur nach localStorage und legt sie der neuen Sitzung wieder
    unter, mit einem sichtbaren Trenner je Sitzungswechsel.
    Muss VOR fl-attribution.js geladen werden. */
!(function () {
  "use strict";

  var SES = "fl_trk_v1";
  var HIST = "fl_hist_v1";
  var MAX_SEITEN = 25;
  var MAX_KLICKS = 40;
  var HALTBAR_TAGE = 30;

  function lies(speicher, schluessel) {
    try {
      var roh = speicher.getItem(schluessel);
      return roh ? JSON.parse(roh) : null;
    } catch (e) {
      return null;
    }
  }

  function schreib(speicher, schluessel, wert) {
    try {
      speicher.setItem(schluessel, JSON.stringify(wert));
    } catch (e) {}
  }

  function trenner() {
    var d = new Date();
    var tag = ("0" + d.getDate()).slice(-2);
    var monat = ("0" + (d.getMonth() + 1)).slice(-2);
    return { p: "+" + tag + "." + monat + ".", t: "sitzung", dur: 0, depth: 0, clicks: 0, exit: "" };
  }

  var laufend = lies(sessionStorage, SES);
  if (!laufend || !laufend.sid) {
    var alt = lies(localStorage, HIST);
    var frisch = alt && alt.at && Date.now() - alt.at < HALTBAR_TAGE * 864e5;
    if (frisch && alt.pages && alt.pages.length) {
      var seiten = alt.pages.slice(-MAX_SEITEN);
      seiten.push(trenner());
      schreib(sessionStorage, SES, {
        sid: alt.sid,
        start: alt.start,
        pages: seiten.slice(-MAX_SEITEN),
        clicks: alt.clicks || [],
        rage: alt.rage || 0,
        dead: alt.dead || 0
      });
    }
  }

  function spiegel() {
    var s = lies(sessionStorage, SES);
    if (!s || !s.pages || !s.pages.length) return;
    schreib(localStorage, HIST, {
      sid: s.sid,
      start: s.start,
      at: Date.now(),
      pages: s.pages.slice(-MAX_SEITEN),
      clicks: (s.clicks || []).slice(-MAX_KLICKS),
      rage: s.rage || 0,
      dead: s.dead || 0
    });
  }

  setInterval(spiegel, 5000);
  addEventListener("visibilitychange", function () {
    if (document.visibilityState === "hidden") spiegel();
  });
  addEventListener("pagehide", spiegel);

  window.flRouteHist = { spiegel: spiegel, lies: function () { return lies(localStorage, HIST); } };
})();